<template>
    <div id="app">
        <b-container fluid class="p-0 m-0">
            <b-row no-gutters class="p-0 m-0">
                <b-col cols="3">
                    <Sidebar/>
                </b-col>
                <b-col cols="9">
                    <b-container fluid class="p-0 m-0">
                        <b-row no-gutters class="p-0 m-0">
                            <b-col cols="12">
                                <Header></Header>
                            </b-col>
                            <b-col cols="12">
                                <Main></Main>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import Sidebar from './components/Sidebar.vue'
    import Main from './components/Main.vue'
    import Header from './components/Toolbar.vue'

    export default {
        name: 'App',
        components: {
            Sidebar,
            Main,
            Header
        },
        mounted() {
            this.$store.commit('wasm');
        }
    }
</script>

<style lang="scss">
    // Import custom SASS variable overrides, or alternatively
    // define your variable overrides here instead
    // Base grayscale colors definitions
    $white: #fff !default;
    $gray-100: #f8f9fa !default;
    $gray-200: #e9ecef !default;
    $gray-300: #dee2e6 !default;
    $gray-400: #ced4da !default;
    $gray-500: #adb5bd !default;
    $gray-600: #6c757d !default;
    $gray-700: #495057 !default;
    $gray-800: #343a40 !default;
    $gray-900: #212529 !default;
    $black: #000 !default;

    // Base colors definitions
    $blue: #007bff !default;
    $indigo: #6610f2 !default;
    $purple: #6f42c1 !default;
    $pink: #e83e8c !default;
    $red: #dc3545 !default;
    $orange: #fd7e14 !default;
    $yellow: #ffc107 !default;
    $green: #28a745 !default;
    $teal: #20c997 !default;
    $cyan: #17a2b8 !default;

    // Theme color default definitions
    $primary: #16a085 !default;
    $secondary: $gray-600 !default;
    $success: #16a085 !default;
    $info: $gray-600 !default;
    $warning: $yellow !default;
    $danger: $red !default;
    $light: $gray-100 !default;
    $dark: $gray-800 !default;

    // This table defines the theme colors (variant names)
    $theme-colors: () !default;
    $theme-colors: map-merge(
                    (
                            'primary': $primary,
                            'secondary': $secondary,
                            'success': $success,
                            'info': $info,
                            'warning': $warning,
                            'danger': $danger,
                            'light': $light,
                            'dark': $dark
                    ),
                    $theme-colors
    );

    // Import Bootstrap and BootstrapVue source SCSS files
    @import '~bootstrap/scss/bootstrap.scss';
    @import '~bootstrap-vue/src/index.scss';

    // General style overrides and custom classes
    body {
        margin: 0;
    }
</style>
